/**
 * Flow running用のエラー定義
 */
export class FlowRuntimeError<T> extends Error {
  /**
   * @var {string} エラータイプ
   */
  protected frame: string = '';

  /**
   * @var {string} エラータイプ
   */
  protected msg: string = '';

  /**
   * 構築関数
   * @param {Error} err
   */
  constructor(err: Error) {
    super();
    this.frame = err.stack?.split('\n')[1].trim() || 'Unable to determine calling function.';
    this.msg = err.message;
    Error.captureStackTrace(this, FlowRuntimeError);
  }

  /**
   * エラータイプを取得
   * @returns {string}
   */
  public getErrFrame(): string {
    return this.frame;
  }

  /**
   * エラーの情報を取得
   */
  override toString(): string {
    return `\n[FlowRuntimeError]: ${this.getErrFrame()}; message: ${this.msg}`;
  }
}
